import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faExclamationCircle,
	faCheckCircle,
	faTimes,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./Notification.module.css";

const Notification = ({ type = "info", message, onClose }) => {
	const icons = {
		error: faExclamationCircle,
		success: faCheckCircle,
		info: faExclamationCircle,
	};

	return (
		<div className={`${styles.notification} ${styles[type]}`}>
			<FontAwesomeIcon icon={icons[type]} className={styles.icon} />
			<span className={styles.message}>{message}</span>
			{onClose && (
				<button className={styles.closeBtn} onClick={onClose}>
					<FontAwesomeIcon icon={faTimes} />
				</button>
			)}
		</div>
	);
};

export default Notification;
